import React, {Component} from 'react';
import Button from 'react-bootstrap/Button';
import {loadStripe} from '@stripe/stripe-js';


//const stripePromise = loadStripe('pk_test_51HF7UVC6mG131FMua4is7Wolrvdogs0LfLasJVGlg1LON8uJPMOmVX2eWLCiIdRH2YtZTi0z9WuKtTNW1O0l8QGw00XTtElaLu');
const stripePromise = loadStripe('pk_live_51HF7UVC6mG131FMueQAKD6a1ZTgyegWjbwYvIdNVdW6AtZJxEqMkkyq49kSRIN0RrYjAyrPoHPiJqNBehdLYDzcy00rYyLnELQ');

export interface PrePaymentProps {
    email: string
    userId: string
}

export class PrePayment extends Component<PrePaymentProps, any> {

    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
    }


    async handleClick(event) {
        console.log(this.props);

        // When the customer clicks on the button, redirect them to Checkout.
        const stripe = await stripePromise;
        if (stripe) {
           console.log(this.props);
           console.log("is it ok ?")
            const {error} = await stripe.redirectToCheckout({
                lineItems: [{
                    price: 'price_1HP7YcC6mG131FMuB4T7448u', // Replace with the ID of your price
                    quantity: 1
                }],
                mode: 'payment',
                customerEmail: this.props.email,
                clientReferenceId: this.props.userId,
                successUrl: "https://myoceanity.com/user/premium/quiz",
                cancelUrl: "https://myoceanity.com/user/premium/quiz",
            });
        }
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `error.message`.
    };


    render() {
        return (
            <div>
                <br/><br/><br/><br/>
                To activate your account and access all the resources of MyOceanity, please click the button
                below. <br/>
                You will be redirected to our payment partner.
                <br/><br/>
                <Button role="link" onClick={this.handleClick}>Activate my account</Button>
            </div>
        );
    }

}

export default PrePayment;